export const inlineStyles = {
  original: 'orignal-style' as const,
  validated: 'validated-style' as const,
  edited: 'edited-style' as const,
  baseEdited: 'base-edit-style' as const,
};
